/**
 * 日期提醒
 * created by lzy 2020.03.19
 */
'use strict';
angular.module('dateReminderModule', ['mgcrea.ngStrap.aside', 'dateReminderServiceModule', 'scheduleCalendarModule', 'scheduleListModule', 'dateReminderTapModule', 'newsCalendarManagementModule']).controller('dateReminderCtrl', ['$scope', '$filter', '$sessionStorage', 'uiCalendarConfig', 'trsHttpService', 'dateReminderService', 'messagePublishService', '$timeout',
    function($scope, $filter, $sessionStorage, uiCalendarConfig, trsHttpService, dateReminderService, messagePublishService, $timeout) {
        initStatus();
        initData();

        /**
          * [initStatus description] 初始化状态
          *
          * @return  {[type]}  [return description]
          */
        function initStatus() {
            $scope.data = {};
            $scope.page = {
                pageNum: 1,
                pageSize: 10,
                total: 20
            };
            $scope.params = {
                serviceid: 'daily',
                method: 'listAndGroupByTime',
                pageNum: 1,
                pageSize: 300,
            };
        }
        
        /**
         * [initData description] 初始化数据
         *
         * @return  {[type]}  [return description]
         */
        function initData() {
            getUserInfo();
        }

        /**
         * [requestData description] 获取选中时间的日程
         *
         * @return  {[type]}  [return description]
         */
        function requestData(params) {
            // let params = {
            //     serviceid: 'daily',
            //     method: 'list',
            //     pageNum: $scope.page.pageNum,
            //     pageSize: 10,
            //     selectDate: $scope.data.selectDate,
            //     userId: $scope.data.curUserInfo.ID,
            //     tenantId: $scope.data.curUserInfo.TENANTID
            // };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getMessageUrl(), params, 'get').then(function(data) {
                $scope.data.scheduleList = data.datas;
                $scope.page = data.summary_info;
            });
        }

        /**
         * [getUserInfo description] 获取当前用户信息
         *
         * @return  {[type]}  [return description]
         */
        function getUserInfo() {
            if (!$scope.data.curUserInfo) {
                $scope.data.curUserInfo = $sessionStorage.get('curUserInfo');
                $scope.params.userId = $scope.data.curUserInfo.ID;
                $scope.params.tenantId = $scope.data.curUserInfo.TENANTID;
            }
        }

        /**
         * [getListData description] 获取列表数据，供回调使用
         *
         * @param   {[type]}  params  [date description] 请求那一天
         *
         * @return  {[type]}        [return description]
         */
        $scope.getListData = function(params) {
            // $scope.params.pageNum = $scope.page.pageNum = 1;
            // if (params && params.pageNum) {
            //     $scope.page.pageNum = params.pageNum;
            // }
            $scope.params = Object.assign($scope.params, params);
            var params = angular.copy($scope.params);
            requestData(params);
        };
    }
]);
